import { gql } from '@apollo/client'
import { BRAND_VALUES_FRAGMENT_COLLECTION } from './BRAND_VALUES_FRAGMENT'
import IMAGE_FRAGMENT from './IMAGE_FRAGMENT'

const BRAND_FRAGMENT = gql`
    ${IMAGE_FRAGMENT}
    ${BRAND_VALUES_FRAGMENT_COLLECTION}
    fragment BrandFields on BrandEntity {
        id
        attributes {
            Site_Discount
            Site_Brand_Name
            Site_Applies_To
            Site_Image {
                ...ImageFields
            }
            Site_Logo {
                ...ImageFields
            }
            Brand_Values {
                ...BrandValuesCollection
            }
            Brand_Redemption_Types {
                data {
                    id
                    attributes {
                        Name
                        Name_Fr
                    }
                }
            }
            Gift_Card_Amounts
            handle
        }
    }
`

export default BRAND_FRAGMENT
